module.exports = __webpack_public_path__ + "img/ingredienten-alcoholvrije-chocoladetiramisu.c598923d.jpeg";